import { Image, RhLink } from "@components";
import classNames from "classnames/bind";
import { getDateRange } from "@/core/utils";
import { FeatureEventsFragment } from "@graphqlTypes"

import styles from "./FeatureEvents.module.scss";
const cx = classNames.bind(styles);

type FeatureEventsSlideProps = FeatureEventsFragment['events']['nodes'][number];

export default function FeatureEventsSlide(props: FeatureEventsSlideProps) {
  if (!('uri' in props)) return null;
  const { uri, title, featuredEventImage, eventData: { startDate, endDate } } = props;
  const date = getDateRange(startDate, endDate);
  return (
    <RhLink href={uri} className={cx("slide")}>
      <div className={cx("slide__image-wrapper")}>
        <Image image={featuredEventImage} />
      </div>
      <div className={cx("slide__content")}>
        <div className={cx("info")}>
          <h2 className={cx("title-lc-s", "title")}>{title}</h2>
          <p className={cx("pill")}>{date}</p>
        </div>
      </div>
    </RhLink>
  )
}